<fieldset ngModelGroup="testedPartyInfoDetails">
  <h5 *ngIf="!(studyVM.study.studyId > 0)">Tested Party Information</h5>
  <div id="dvTestedPartyDetails">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <span class="ey-float-label">
            <input
              type="text"
              class="form-control"
              id="testedPartyName"
              name="testedPartyName"
              pattern="{{ regularExpressionPattern.BasicPattern }}"
              [(ngModel)]="studyVM.study.testedPartyName"
              #testedPartyName="ngModel"
              maxlength="255"
              appLabelFloat
            />
            <label for="testedpartyName">Tested Party Name</label>
          </span>
          <span class="help-block" *ngIf="testedPartyName.errors?.pattern"> special characters are not allowed. (for example: !@#$%^&* etc) </span>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="studyVM.isWorldRegionsEnabledOnTestedParty">
      <div class="col-12">
        <div class="form-group">
          <div class="p-checkbox-grp" ngbTooltip="{{ 'testedPartyInfo_worldRegions' | tpbTooltip }}" tooltipClass="lengthyText">
            <label for="region-country">World regions (geographical)</label>
            <p-tree
              id="testedParty"
              name="testedParty"
              (onNodeSelect)="nodeSelect($event)"
              (onNodeUnselect)="nodeUnselect($event)"
              [value]="studyVM.testedpartyregionCountries_multi"
              [(selection)]="selectedTestedPartyCountryNodes"
              selectionMode="checkbox"
              [propagateSelectionUp]="true"
              [propagateSelectionDown]="true"
            >
            </p-tree>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <div [ngClass]="{ 'has-error': ShowValidationMessage(functionId) }">
            <span class="ey-float-label">
              <select
                class="form-control form-select"
                id="functionId"
                name="functionId"
                [(ngModel)]="studyVM.study.functionId"
                #functionId="ngModel"
                appLabelFloat
                required
              >
                <option *ngIf="!studyVM.study.functionId" [value]="undefined" disabled selected></option>
                <option *ngFor="let functionType of studyVM.functionTypes" [ngValue]="functionType.functionId">
                  {{ functionType.functionName }}
                </option>
              </select>
              <label for="functionType">Function</label>
            </span>
            <span class="help-block" *ngIf="ShowValidationMessage(functionId) && functionId.errors.required"> Please select function </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h5>Industries and Sectors</h5>
  <div id="dvIndustries">
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <div class="tested-party-industry-autocomplete">
            <span class="ey-float-label">
              <p-autoComplete
                class="ng-invalid ng-dirty"
                id="industryId"
                name="industryId"
                [(ngModel)]="selectedIndustry"
                [forceSelection]="true"
                #industryId="ngModel"
                [dropdown]="true"
                [suggestions]="filteredIndustries"
                (completeMethod)="filterIndustries($event)"
                (onSelect)="IndustrySelected($event)"
                (onClear)="clearTextbox()"
                [size]="10"
                [minLength]="2"
                inputStyleClass="form-control team-member-input ey-field"
                appLabelFloat
                field="industryName"
              />
              <label for="industry">Industry/Sector</label>
            </span>
            <span class="help-block" *ngIf="showValidationMessage"> Please select industries and sectors </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h5>Tested Party Business Description</h5>
  <div id="dvBusinessDesc">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <div [ngClass]="{ 'has-error': ShowValidationMessage(businessDesc) }">
            <span class="ey-float-label ey-textarea-label">
              <textarea
                appAutosize
                appLabelFloat
                class="form-control"
                [rows]="5"
                id="businessDescription"
                name="businessDescription"
                [(ngModel)]="studyVM.study.businessDescription"
                minlength="{{ testedPartyBusinessDescriptionMinLength }}"
                maxlength="5000"
                #businessDesc="ngModel"
                [ngbTooltip]="businessDescSample"
                tooltipClass="lengthyText"
                required
                pattern="{{ regularExpressionPattern.BusinessDescPattern }}"
              >
              </textarea>
              <label for="businessDescription">Business Description</label>
            </span>
            <span class="help-block" *ngIf="ShowValidationMessage(businessDesc) && businessDesc.errors.required">
              Please enter business description
            </span>
            <span class="help-block" *ngIf="businessDesc.errors?.pattern"> special characters are not allowed. (for example: !@#$%^&*() etc) </span>
            <span class="help-block" *ngIf="businessDesc.errors?.minlength">
              Description must be at least {{ testedPartyBusinessDescriptionMinLength }} characters.
            </span>
          </div>
        </div>
      </div>
    </div>
    <ng-template #businessDescSample>
      <div class="text-left">
        <div class="business-desc-warning">Please do not include Client Name or Tested Party Name within "Tested Business Description"</div>
        <div class="mb-1">Please include the following components in the description: [industry] + [function] + [sample of products / services].</div>
        <div class="mb-1">Below are the two samples for your reference:</div>
        <ul>
          <li>
            Sample 1: The company is engaged in the distribution of electrical premium and household appliances. Its products include refrigerators,
            home appliances, air conditioning equipment, freezers, bakery and confectionery equipment, fans, vacuum cleaners among others.
          </li>
          <li>
            Sample 2: The company is engaged in the provision of telecommunications services. The company offers telecom services, including IP
            telephone, internet data transmission, fax and telegraph, wireless access, and network hosting. The company also operates optical
            transmission network, telephone switching network and broadband data network.
          </li>
          <li>Minimum characters: {{ testedPartyBusinessDescriptionMinLength }}</li>
        </ul>
      </div>
    </ng-template>
  </div>
</fieldset>
